import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../components/Logo";

const LoanHeader = () => {
  return (
    <header id="header">
      {" "}
      <div className="header_top border-bottom d-lg-block d-none">
        <nav className="navbar-expand-lg py-3 bg-gray">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-12">
                <Link to="/" className="navbar-brand d-lg-block d-none mr-20">
                  {/* <img src={logo} alt="logo" /> */}
                  <Logo />{" "}
                </Link>{" "}
                {/* <a className="navbar-brand d-lg-block d-none" href="index.html">

                          <img src="img/logo.png" width="180" alt=""/>

                        </a> */}{" "}
              </div>{" "}
              <div className="col-xl-4 col-lg-4 col-md-12">
                {" "}
                <div className="text-center mt-2">
                  <h4>Discussion Board</h4>{" "}
                </div>{" "}
              </div>{" "}
              <div className="col-xl-4 col-lg-4 col-md-12">
                {" "}
                <div className="d-flex justify-content-end mt-3">
                  <i className="fas fa-lock"></i>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </nav>{" "}
      </div>{" "}
    </header>
  );
};

export default LoanHeader;
